import { render, staticRenderFns } from "./assign-driver.vue?vue&type=template&id=6c870ec8&scoped=true&"
import script from "./assign-driver.vue?vue&type=script&lang=js&"
export * from "./assign-driver.vue?vue&type=script&lang=js&"
import style0 from "./assign-driver.vue?vue&type=style&index=0&id=6c870ec8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c870ec8",
  null
  
)

export default component.exports